<template>
  <div class="mb-2 mt-1">
    <v-layout
      row
      pa-2
    >
      <v-row class="py-1 px-2">
        <v-col class="successPlot mt-6">
          <v-flex
            v-for="suggested in suggestedFields"
            :key="suggested.key"
            xs12
            sm6
            lg4
            xl3
            pr-4
          >
            <component
              :is="suggested.type"
              v-if="suggested.type === 'radio'"
              v-model="suggestedProp[suggested.key]"
              :append-text="suggested.unit"
              :label="suggested.label"
              :disabled="suggested.isReadonly"
              :field-key="suggested.key"
              :items="suggested.items"
            />
            <component
              :is="suggested.type"
              v-else
              :value="suggestedMetricsValue(suggested.key)"
              :append-text="suggested.unit"
              :label="suggested.label"
              :disabled="suggested.isReadonly"
            />
          </v-flex>
        </v-col>
      </v-row>
      <v-row class="py-1 px-2">
        <v-col class="suggestPlot pt-3">
          <v-flex
            v-for="(field, index) in successFields"
            :key="index"
            xs12
            sm6
            lg4
            xl3
            pr-4
          >
            <component
              :is="field.type"
              v-if="field.type === 'radio'"
              v-model="successProp[field.key]"
              :append-text="field.unit"
              :label="field.label"
              :disabled="field.isReadonly"
              :field-key="field.key"
              :items="field.items"
            />
            <component
              :is="field.type"
              v-else
              :value="successMetricsValue(field.key)"
              :append-text="field.unit"
              :label="field.label"
              :disabled="field.isReadonly"
            />
          </v-flex>
        </v-col>
      </v-row>
    </v-layout>
  </div>
</template>

<script>
import { get } from "lodash";
import Number from "@/components/form/NumberInput";
import NumberInput from "@/components/form/NumberInput";
import Dropdown from "@/components/form/Dropdown";
import Radio from "@/components/form/Radio";

export default {
  name: "Metrics",

  components: { Number, NumberInput, Dropdown, Radio },

  props: {
    schema: { type: Array, required: true, default: () => [] },
    successMetrics: { type: Object, required: true, default: () => ({}) },
    suggestedMetrics: { type: Object, required: true, default: () => ({}) },
  },
  data() {
    return {
      successFields: [],
      suggestedFields: [],
      rounded: [],
      suggestedProp:this.suggestedMetrics,
      successProp:this.successMetrics
    };
  },
  watch:{
      suggestedMetrics(value){
      this.suggestedProp = value;
      },
      successMetrics(value){
      this.successProp = value;
      }
  },
  mounted() {
    this.successFields = this.schema;
    this.suggestedFields = this.schema;
  },
  methods: {
    successMetricsValue(key) {
      return get(this.successMetrics, key);
    },
    suggestedMetricsValue(key) {
      return get(this.suggestedMetrics, key);
    },
  },
};
</script>
<style scoped>
.successPlot {
  border: 3px solid #ef5151;
  height: auto;
  margin-left: 4px;
  margin-right: 8px;
}
.flex.sm6 {
  max-width: 100%;
}
.suggestPlot {
  border: 3px solid #0035c7;
  height: auto;
  margin-left: 4px;
  margin-right: 8px;
}
</style>
